
import {
  WDCardTabs,
  WDApi,
  WDFormOptionselect
} from 'wd';

import GLLookupCard from './gl-lookup-card';
import VendorLookupCard from './vendor-lookup-card';
import CostcodeLookupCard from './costcode-lookup-card';
import TransactionsCard from './transactions-card';

/**
  Events:
  kiosks:selected -> when an kiosk is picked, it passes the kiosk back to the caller
  */

export default class LookupCards extends WDCardTabs
{
  #companySelector;

  constructor()
  {
    super({ 
      navigation_mode: 'tabs',
      collapsible: false,
      breakpoint: 'md',
      tab_position: 'left',
      title: 'TAI Lookup'
    }).classList.add('lookup-cards');
    
  };

  connectedCallback()
  {
    super.connectedCallback();

    const h = this.navbar;      //init the navbar first so we can lay everything out correctly
    this.addCompanySelector();

    const glCard = new GLLookupCard();
    this.addCard(glCard,'GL Accounts');

    const ccCard = new CostcodeLookupCard();
    this.addCard(ccCard, 'Cost Codes');

    const vendCard = new VendorLookupCard();
    this.addCard(vendCard, 'Vendors');

    const trannyCard = new TransactionsCard();
    this.addCard(trannyCard, 'Transactions');

    //if we have a card shortcode in the uri, use that
    const arr = ['vendors','glaccounts','costcodes','transactions'];
    const lastSegment = window.location.pathname.split('/').pop();
    if (arr.includes(lastSegment)) localStorage.selectedCard = 'wd-card-' + lastSegment; 

    //store the current card
    this.on('card:shown',evt => {

      localStorage.selectedCard = evt.detail.dataset.shortcode;
      
      if (window?.hsc)
      {
        const size = (this.activeCard == trannyCard) ? 'xlarge' : 'default';

        document.body.dataset.hammerize = size;   //save for next time window is opened
        window.hsc.resize(size);
      }
  
    });

    this.showCard(localStorage?.selectedCard || 'wd-card-glaccounts');
  };

  get company() {
    return this.#companySelector ? this.#companySelector.value : {};
  }

  get companySelector()
  {
    return this.#companySelector;
  }

  addCompanySelector()
  {
    const curVal = localStorage?.company !== undefined ? JSON.parse(localStorage.company) : null;

    this.#companySelector = new WDFormOptionselect({
      name:'company_id',
      fetch: new WDApi('/lookup/companies'),
      placeholder: 'Select A Company',
      value: curVal
    });

    this.#companySelector.once('options:set',() => {
      if (this.#companySelector.value) this.trigger('company:selected');
    })

    this.#companySelector.on('options:set',() => {
      if (!this.#companySelector.value) this.#companySelector.input.focus();
    });

    this.#companySelector.input.addEventListener('click',() => {
      this.#companySelector.input.select();
    });

    this.#companySelector.on('change',() => {

      this.trigger('company:selected');

      if (this.#companySelector.value)
      {
        localStorage.company = JSON.stringify(this.#companySelector.value);
      }
      else
      {
        delete(localStorage.company);
      }

    });

    this.#companySelector.input.classList.add('form-control-sm');

    const wrapper = wdc('<div class="company-wrapper"/>');
    this.prepend(wrapper);

    wrapper.append(this.#companySelector);

  };
}

customElements.define('lookup-cards',LookupCards);

